var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _text, _line, _line2, _line3, _line4, _line5, _line6, _text2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOregonSportsNewsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "60,140 100,40 300,40 340,140 300,240 100,240",
    fill: "#1B5A96",
    stroke: "#ffffff",
    strokeWidth: 3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "70,140 105,50 295,50 330,140 295,230 105,230",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.5
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "90,120 110,90 130,110 150,80 170,100 190,70 210,90 230,60 250,80 270,50 290,70 310,90 310,120 90,120",
    fill: "#ffffff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "95,120 100,100 105,120",
    fill: "#ffffff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "305,120 310,100 315,120",
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 180,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 48,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#ffffff"
  }, "OREGON")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 190,
    x2: 120,
    y2: 190,
    stroke: "#ffffff",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 195,
    x2: 110,
    y2: 195,
    stroke: "#ffffff",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 200,
    x2: 115,
    y2: 200,
    stroke: "#ffffff",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 190,
    x2: 320,
    y2: 190,
    stroke: "#ffffff",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 195,
    x2: 320,
    y2: 195,
    stroke: "#ffffff",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 285,
    y1: 200,
    x2: 320,
    y2: 200,
    stroke: "#ffffff",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 215,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "normal",
    textAnchor: "middle",
    fill: "#ffffff",
    letterSpacing: "3px"
  }, "SPORTS NEWS")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 215,
    r: 2,
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 215,
    r: 2,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOregonSportsNewsLogo);
export default __webpack_public_path__ + "static/media/oregon-sports-news-logo.4376161842ff4973e7f25ff5d666957b.svg";
export { ForwardRef as ReactComponent };